import { useContext } from "react"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { MODEL_PROVIDER } from "@utils/CONST"
import styles from "./index.module.scss"

const ModelProvider = () => {
    const {
        modelProvider,
        setModelProvider,
        setModelKeyList,
        setSceneKeyList,
    } = useContext(GenerateContext)

    const items = [
        { label: "ArcMuse", value: MODEL_PROVIDER.ARCMUSE },
        { label: "全能模型", value: MODEL_PROVIDER.SOTA, teamIcon: true },
    ]

    const handleProviderClick = (value) => {
        if (value == MODEL_PROVIDER.SOTA && modelProvider != MODEL_PROVIDER.SOTA) {
            // 切换到全能模型时，清空已选模特/背景
            setModelKeyList([])
            setSceneKeyList([])
        }
        setModelProvider(value)
    }

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>模型选择</p>
            <div className={styles.PickerContent}>
                {
                    items.map(item => (
                        <div
                            key={item.value}
                            className={`${styles.PickerItem} ${modelProvider == item.value ? styles.actived : ''}`}
                            onClick={() => handleProviderClick(item.value)}
                        >
                            <span>{item.label}</span>
                            {item.teamIcon && <span className={styles.teamIcon}></span>}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ModelProvider
